export const generateComponentTheme = theme => theme
